import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactService } from '../../services/contact.service';
import {
  BehaviorSubject,
  mergeMap,
  of,
  share,
  shareReplay,
  switchMap,
  take
} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SelectContactComponent } from '../select-contact/select-contact.component';
import { Contact } from 'src/app/models/contact';
import { ContactMethodListPipe } from '../contact-method-list.pipe';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-document-contact',
  templateUrl: './document-contact.component.html',
  standalone: true,
  imports: [
    MatIconButton,
    MatTooltip,
    MatIcon,
    AsyncPipe,
    ContactMethodListPipe
  ]
})
export class DocumentContactComponent {
  @Input() set contactId(id: number | null) {
    this.contactId$.next(id);
  }

  @Input() customerId: number;
  @Input() readonly = false;

  @Output() contactSelected = new EventEmitter<number>();

  private contactId$ = new BehaviorSubject<number>(null);

  contact$ = this.contactId$.pipe(
    switchMap((id) => {
      if (!id) {
        return of(null);
      }
      return this.contactService.get(id);
    }),
    shareReplay(1)
  );

  constructor(
    private contactService: ContactService,
    private matDialog: MatDialog
  ) {}

  openSelectContactDialog() {
    this.contact$
      .pipe(
        take(1),
        mergeMap((contact) => {
          return this.matDialog
            .open(SelectContactComponent, {
              data: { customerId: this.customerId, contact },
              minWidth: '30vw',
              maxWidth: 600
            })
            .afterClosed()
            .pipe(take(1));
        })
      )
      .subscribe((contact: Contact | null | 'CANCELLED') => {
        if (contact === 'CANCELLED') {
          return;
        }
        this.contactId$.next(contact?.id ?? null);
        this.contactSelected.emit(contact?.id ?? null);
      });
  }
}
